import { useEffect } from 'react';
import { cloneDeep } from 'lodash';
import useServiceData from '../../../../../hooks/useServiceData';
import { getIsAvailableEvent, NEW_YEAR } from '../../../../../constants/events';
import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions';
import useGetIsTruthTime from '../../../../../hooks/shared/time/useGetIsTruthTime';
import { defaultStore } from '../../../../../translations';
import { newYearModalChallengesContent } from '../../../../../constants/copyright-modals';
import { useChallenges } from '../../../../../redux/reducer/content';
import { CHALLENGES } from '../../constants/tabs';

export default function useChallengesModals() {
  const { activeTab } = useChallenges();
  const { addModal } = useModalsDataActions();
  const { get, save } = useServiceData();
  const getIsTruthTime = useGetIsTruthTime();

  useEffect(() => {
    if (activeTab !== CHALLENGES || !getIsTruthTime({ forAll: '2026-01-01T00:00' })) return;

    const modalsData = get('modalsData') ?? {};

    if (!modalsData?.startNewYear2026 && getIsAvailableEvent(defaultStore, NEW_YEAR)) {
      addModal({ type: 'aboutModal', props: cloneDeep(newYearModalChallengesContent) });
      save('modalsData', { ...modalsData, startNewYear2026: true });
    }
  }, [activeTab]);
}
